module.exports = __webpack_public_path__ + "img/saude-color.27ac66c5.svg";